/*********
 * TipFields handles and populates data to the Tip HTML elements
 */

(function($){
    $.TipFields = function(options) {
        this._element = options.element || null;
        this._overlay_data = options.overlay_data || {};
        this._meta = options.meta;
        
        this._field_types = {
            TEXT: "text",
            IMAGE: "image",
            LINK: "link"
        };

        // functions that populate elements for each field type
        // e.g. TEXT modifies innerText and adds langkey, IMAGE modifies the SRC of an image
        this._field_handlers = {}; 
        this._add_basic_handlers();

        // get overlay_data from data-tip-<type>-* attributes
        this._data_attr_regexp = /(data-tip)-([\w]+)-(.+)/;
        if (this._element) {
            this._populate_data_from_element_attributes();
        }
    }; 

    $.TipFields.noimage = "data:image/jpeg;base64,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";

    function _sanitize_field_name(field_name) {
        return field_name.replace("-","_");
    }

    $.TipFields.prototype = { 

        _populate_data_from_element_attributes: function() { 
            var element_attributes = this._element.getAttributeNames();
            for (var i = 0; i < element_attributes.length;i++) {
                var attr = element_attributes[i];
                var matches = this._data_attr_regexp.exec(attr);

                if (matches && matches.length == 4) { 
                    var type = matches[2];
                    var field_name = _sanitize_field_name(matches[3]);

                    // add field if it does not exists
                    var field_list = this._get_field_list(type);
                    if (field_list.indexOf(field_name) < 0) {
                        field_list.push(field_name);
                    }
 
                    this._overlay_data[field_name] = this._element.getAttribute(attr);
                }
            } 
        },

        populate: function(tip_element) {
            // for each field type
            for(var type_key in this._field_types) {
                var type = this._field_types[type_key];
                var handler = this._field_handlers[type] || null;

                // if handler exist
                if (handler) {
                    // get the field map of current type
                    var field_list = this._get_field_list(type);

                    // for each of the registered fields in field_list
                    for (var i = 0; i < field_list.length;i++) {
                        var field_name = field_list[i];
                        var datum = this._overlay_data[field_name];
                        var child_selector = '.' + this._get_prefix(type) + '-' + field_name;
                        
                        var children = tip_element.querySelectorAll(child_selector);
                        for (var child_index = 0; child_index < children.length; child_index++) {
                            var child_element = children[child_index];
                            handler(child_element, datum);
                        } 
                    }
                }
            }

            // if it has images lists handle them
            if (Array.isArray(this._overlay_data.images) && this._overlay_data.images.length > 0) {

                var tip_img_element = tip_element.querySelector(".tip-img");
                if (tip_img_element) {
                    // prepare carousel
                    var carousel = document.createElement("div");
                    carousel.id = tip_element.id + "-carousel";
                    carousel.classList.add("carousel");
                    carousel.classList.add("slide");

                    var carousel_inner = document.createElement("div");
                    carousel_inner.classList.add("carousel-inner");
                    carousel.appendChild(carousel_inner);
                    
                    // add images to carousel
                    var i, overlay_img;
                    for(i = 0; i < this._overlay_data.images.length; i++) {
                        overlay_img = this._overlay_data.images[i];
                        var description = overlay_img.description || "";

                        // create carousel item
                        var carousel_item = document.createElement("div"); 
                        carousel_item.classList.add("carousel-item");
                        if (i == 0) {
                            carousel_item.classList.add("active");
                        }

                        // create carousel image
                        var img_element = document.createElement("img");
                        img_element.classList.add("d-block");
                        img_element.classList.add("w-100");
                        img_element.dataset.dismiss = "tip";
                        img_element.src = overlay_img.filename;

                        // caption
                        var caption_element = document.createElement("div");
                        caption_element.classList.add("carousel-caption");
                        caption_element.classList.add("d-none");
                        caption_element.classList.add("d-md-block");
                        caption_element.dataset.dismiss = "tip";
                        caption_element.innerHTML = "<h5>" + description + "</h5"; 

                        // add to item
                        carousel_item.appendChild(img_element);
                        carousel_item.appendChild(caption_element);

                        // add item to carousel inner div
                        carousel_inner.appendChild(carousel_item); 
                       
                    }

                    if (this._overlay_data.images.length > 1) {
                        // prev control
                        var control_prev = document.createElement("a");
                        control_prev.classList.add("carousel-control-prev");
                        control_prev.dataset.slide = "prev";
                        control_prev.href = "#" + carousel.id;
                        control_prev.innerHTML = '<span class="carousel-control-prev-icon" aria-hidden="true"></span>';

                        // next control
                        var control_next = document.createElement("a");
                        control_next.classList.add("carousel-control-next");
                        control_next.dataset.slide = "next";
                        control_next.href = "#" + carousel.id;
                        control_next.innerHTML = '<span class="carousel-control-next-icon" aria-hidden="true"></span>';
                        
                        // add control to carousel
                        carousel.appendChild(control_prev);
                        carousel.appendChild(control_next);
                    }

                    tip_img_element.appendChild(carousel);
                    jQuery(carousel).carousel({
                        interval: false 
                    });
                }
            }
        },

        get_data: function() {
            var data = {};
            for(var type in this._field_types) {
                Object.assign(data, this._get_type_data(type));
            }

            return data;
        },

        _text_handler: function(element, datum) {
            element.innerText = datum;
            element.dataset.langkey = datum;
        },

        _img_handler: function(element, datum) {
            if (datum) {
                element.src = datum;
            }
            else {
                element.src = $.TipFields.noimage;
            }
        },

        _link_handler: function(element, datum) {
            if (datum) {
                element.href = datum;
            }
            else {
                element.href = '#';
                element.classList.add('link-disabled');
            }

            if (element.innerText.trim() === "") {
                element.innerText = datum;
            }
        },

        _add_basic_handlers: function(){
            this._add_field_handler(this._field_types.TEXT, this._text_handler.bind(this));
            this._add_field_handler(this._field_types.IMAGE, this._img_handler.bind(this));
            this._add_field_handler(this._field_types.LINK, this._link_handler.bind(this));
        },

        _add_field_handler: function(type, func) {
            var type_key = type.toUpperCase();
            // add field type if not listed in types
            if (!(type_key in this._field_types)) {
                this._field_types[type_key] = type.toLowerCase();
            }

            this._field_handlers[type] = func;
        },
        
        _get_type_data: function(type) {
            var map = this._get_field_list(type);
            var data = {};

            for(var property in map) {
                var field_name = map[property]; 
                data[this._get_prefix(type) + this._first_ucase(field_name)] = this._overlay_data[field_name];
            }

            return data;
        },

        _get_prefix: function(type) {
            return 'tip-' + type;
        },

        _get_field_list: function(type) {
            // check in meta first
            if (this._meta && this._meta.fields && typeof(this._meta.fields[type]) !== "undefined") {
                return this._meta.fields[type];
            }

            // check in object
            var list_name = type + '_fields';
            if (typeof(this._overlay_data[list_name]) === "undefined") {
                this._overlay_data[list_name] = [];
            }

            return this._overlay_data[list_name];
        },
    }; 
})(ABDOMap);
